<v-form
  (valueChange)="formValueChange($event)"
  *ngIf="{
    disabled: disabled$ | async,
    prefill: prefillConfiguration$ ? (prefillConfiguration$ | async) : null
  } as obs"
>
  <v-input
    name="configurationTitle"
    [title]="'configurationTitle' | pluginTranslate: pluginId | async"
    [margin]="true"
    [defaultValue]="obs.prefill?.configurationTitle"
    [disabled]="obs.disabled"
    [required]="true"
  >
  </v-input>
  <v-input
    name="alfrescoBaseUrl"
    [title]="'alfrescoBaseUrl' | pluginTranslate: pluginId | async"
    [margin]="true"
    [defaultValue]="obs.prefill?.alfrescoBaseUrl"
    [disabled]="obs.disabled"
    [required]="true"
  >
  </v-input>
  <v-input
    name="username"
    [title]="'username' | pluginTranslate: pluginId | async"
    [margin]="true"
    [defaultValue]="obs.prefill?.username"
    [disabled]="obs.disabled"
    [required]="true"
  >
  </v-input>
  <v-input
    name="password"
    type="password"
    [title]="'password' | pluginTranslate: pluginId | async"
    [margin]="true"
    [defaultValue]="obs.prefill?.password"
    [disabled]="obs.disabled"
    [required]="true"
  >
  </v-input>
  <v-input
    name="tezzaAppBaseUrl"
    [title]="'tezzaAppBaseUrl' | pluginTranslate: pluginId | async"
    [margin]="true"
    [defaultValue]="obs.prefill?.tezzaAppBaseUrl"
    [disabled]="obs.disabled"
    [required]="true"
  >
  </v-input
  ><v-input
    name="tezzaRmBaseUrl"
    [title]="'tezzaRmBaseUrl' | pluginTranslate: pluginId | async"
    [margin]="true"
    [defaultValue]="obs.prefill?.tezzaRmBaseUrl"
    [disabled]="obs.disabled"
    [required]="true"
  >
  </v-input>
  <v-input
    name="emailFrom"
    [title]="'emailFrom' | pluginTranslate: pluginId | async"
    [margin]="true"
    [defaultValue]="obs.prefill?.emailFrom"
    [disabled]="obs.disabled"
    [required]="true"
  >
  </v-input>
  <ng-container *ngIf="{documentDefinitionSelectItems: documentDefinitionSelectItems$ | async} as vars">
    <v-select
      [items]="vars.documentDefinitionSelectItems"
      [multiple]="true"
      [margin]="true"
      name="defaultDossiers"
      [title]="'defaultDossiers' | pluginTranslate: pluginId | async"
      [disabled]="obs.disabled"
      [defaultSelectionIds]="obs.prefill?.defaultDossiers"
      [required]="true"
      [loading]="!vars.documentDefinitionSelectItems"
      [tooltip]="'defaultDossiersTooltip' | pluginTranslate: pluginId | async"
    ></v-select>
    <v-select
      [items]="vars.documentDefinitionSelectItems"
      [multiple]="true"
      [margin]="true"
      name="defaultObjectDossiers"
      [title]="'defaultObjectDossiers' | pluginTranslate: pluginId | async"
      [disabled]="obs.disabled"
      [defaultSelectionIds]="obs.prefill?.defaultObjectDossiers"
      [required]="false"
      [loading]="!vars.documentDefinitionSelectItems"
      [tooltip]="'defaultObjectDossiersTooltip' | pluginTranslate: pluginId | async"
    ></v-select>
  </ng-container>
</v-form>
